if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    window.bssB2BHooks = window.bssB2BHooks || {
        actions: {},
        filters: {},
    };
    window.BSS_B2B = window.BSS_B2B || {};
    window.BSS_B2B.addAction = (tag, callback) => {
        window.bssB2BHooks.actions[tag] = callback;
    };
    window.BSS_B2B.addFilter = (tag, value) => {
        window.bssB2BHooks.filters[tag] = value;
    };

    BSS_B2B.addFilter('custom:product_page/cp_pl_show_price', (...data) => {
        const { price } = data[1].cpPrices;
        console.log(price);
        const qty = +document.querySelector("[id^='Quantity-product-']").value;
        const total = document.querySelector("[bss-custom-total]");
        if (total) {
            total.textContent = `- ${BSS_B2B.formatMoney(price * qty)}`;
        }
        return data[0];
    });
    
    document.addEventListener("DOMContentLoaded", e => {
        const quantityInput = document.getElementById('Quantity-product-template');
        quantityInput.addEventListener('change', function (e) {
            const newValue = parseInt(e.target.value, 10);
            const element = document.querySelector("[bss-b2b-product-form='main'] [bss-b2b-variant-price], [bss-b2b-product-form='feature'] [bss-b2b-variant-price]");
            let priceFinal = 0;
            if (element) {
                const urlParams = new URLSearchParams(window.location.search);
                const variant_id = urlParams.get('variant') || element.getAttribute('bss-b2b-variant-id');
                const product_id = element.getAttribute('bss-b2b-product-id');
                const variantStorage = BSS_B2B.storage.variantStorage.get(parseInt(variant_id));

                let originPriceAfterCP = BSS_B2B.utils.getModifyPrice(variantStorage, 'qb');
                if (!originPriceAfterCP) {
                    originPriceAfterCP = BSS_B2B.storage.variantStorage.store.get(parseInt(variant_id)).price;
                }
                if (!originPriceAfterCP) {
                    originPriceAfterCP = BSS_B2B.storage.productStorage.store.get(parseInt(product_id)).price;
                }
                priceFinal = originPriceAfterCP;
                const total = document.querySelector("[bss-custom-total]");
                if (total) {
                    setTimeout(() => {
                        total.textContent = `- ${BSS_B2B.formatMoney(priceFinal * newValue)}`;
                    }, 500);
                }
            }
        });
    })

}